<div class="label-title">{{ label }}</div>
<ng-content></ng-content>
